import React, { useState } from "react";
import { useAuth0 } from "../react-auth0-spa";


const NavBar = () => {
  const [ token, setToken ] = useState();
  const { isAuthenticated, loginWithRedirect, logout, user, getTokenSilently } = useAuth0();
  
  getTokenSilently().then((accessToken) => {
    setToken(accessToken);
  });
  
  return (
    <div>
      {!isAuthenticated && (<button onClick={() => loginWithRedirect({})}>Log in</button>)}
      {isAuthenticated && <button onClick={() => logout()}>Log out</button>}
      {isAuthenticated && <p>{user.email}- {token}</p>}
    </div>
  );
};

export default NavBar;